import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FirmService } from '../../../../Services/firm.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NotificationService } from '../../../../Services/notification.service';
import { AuthService } from '../../../../Services/auth.service';
import { UserServiceService } from '../../../../Services/user.service';
import { UserAccessService } from '../../../../Services/UserAccess/user-access.service';

@Component({
  selector: 'app-ca-header',
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './ca-header.component.html',
  styleUrl: './ca-header.component.css'
})
export class CaHeaderComponent implements OnInit {

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;
  userImg: any;

  router = inject(Router);
  menuOpen = false;
  mobileExpanded: string | null = null;

  // All possible menu options — paths match gst-admin-access-control paths
  private allNavbarOptions = [
    {
      lable: 'GST Bill',
      path: '/invoice-gst-panel',
      visible: false,
      submenu: [
        { path: '/invoice-gst-panel', lable: 'GST Invoice List', visible: false },
        { path: '/invoice-gst', lable: 'GST Invoice Preview', visible: false }
      ]
    },
    {
      lable: 'Purchase Bill',
      path: '/purchase-bill',
      visible: false,
      submenu: [
        { path: '/purchase-bill', lable: 'Purchase Bill Form', visible: false }
      ]
    },
    {
      lable: 'Reports',
      path: '/purchase-report',
      visible: false,
      submenu: [
        { path: '/purchase-report', lable: 'Purchase Bills', visible: false },
        { path: '/gst-bill-report', lable: 'GST Bills', visible: false }
      ]
    },
    {
      lable: 'Customers',
      path: '/gst-customer-list',
      visible: false,
      submenu: [
        { path: '/gst-customer-list', lable: 'GST Customer List', visible: false }
      ]
    },
    {
      lable: 'Settings',
      path: '/gst-settings',
      visible: false,
      submenu: [
        { path: '/gst-settings', lable: 'GST Settings', visible: false }
      ]
    },
    {
      lable: 'Accounts',
      path: '/accounts',
      visible: false,
      submenu: [
        { path: '/accounts', lable: 'Accounts List', visible: false },
        { path: '/account-ledger', lable: 'Account Ledger', visible: false }
      ]
    },
    {
      lable: 'Daybook',
      path: '/daybook',
      visible: false,
      submenu: [
        { path: '/daybook', lable: 'Daybook', visible: false }
      ]
    },
    {
      lable: 'Profile',
      path: '/ca-account',
      visible: false,
      submenu: []
    },
    {
      lable: 'Trial Balance',
      path: '/trail-balance',
      visible: false,
      submenu: [
        { path: '/trail-balance', lable: 'Trial Balance', visible: false }
      ]
    }
  ];

  navbarOptions: typeof this.allNavbarOptions = [];

  constructor(
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private userService: UserServiceService,
    private userAccessService: UserAccessService
  ) { }

  ngOnInit(): void {
    const id = this.authService.getUserId();
    this.getProfile(id);
    this.loadMenuFromPermissions(id);
  }

  loadMenuFromPermissions(userId: any) {
    const userRole = this.authService.getUserRole();
    // This will evaluate to true for 'Owner', 'owner', 'OWNER', etc.
    const isOwner = userRole?.toLowerCase() === 'owner';

    // Owner always has full access — skip DB permissions entirely
    if (isOwner) {
      this.navbarOptions = this.allNavbarOptions
        .filter(item => item.path !== '/ca-account')
        .map(item => ({ ...item, visible: true, submenu: item.submenu.map(s => ({ ...s, visible: true })) }));
      return;
    }

    this.userAccessService.getUserAccess(userId).subscribe({
      next: (res: any) => {
        const data = res?.data;
        const allowedPaths: string[] = [
          ...(data?.mainmenu_visibility || []),
          ...(data?.submenu_visibility || [])
        ].map((r: string) => (r.startsWith('/') ? r : '/' + r));

        this.navbarOptions = this.allNavbarOptions
          .filter(item => item.path !== '/ca-account')
          .map(item => ({
            ...item,
            visible: allowedPaths.some(p => p === item.path || p.startsWith(item.path + '/')),
            submenu: item.submenu.map(sub => ({
              ...sub,
              visible: allowedPaths.includes(sub.path)
            }))
          }))
          .filter(item => item.visible);
      },
      error: () => {
        this.navbarOptions = [];
      }
    });
  }

  getProfile(id: any) {
    this.userService.getCurrentUserProfile(id).subscribe((res: any) => {
      this.userImg = res?.data?.[0]?.doc_user_img;
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  toggleSubmenu(path: string) {
    this.mobileExpanded = this.mobileExpanded === path ? null : path;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;
    this.mobileExpanded = null;
  }

  isUserMenuOpen = false;

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;

    if (!currentTarget) {
      this.isUserMenuOpen = false;
      return;
    }

    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.isUserMenuOpen = false;
    }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess(
      'Logged out successfully.',
      'Logout'
    );
    this.authService.logout();
  }
}